import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { createUseStyles } from "react-jss";
import { useFormContext } from "./Form";
import { Search } from "./Search";
import { classNames } from "./utils/classNames";
import parseChildren from "./utils/parseChildren";
import { withFormWrapper } from "./withFormWrapper";
var BORDER_STYLE = {
    width: 1,
    color: "#D5DFE7",
    style: "solid",
};
var styles = {
    panes: {
        display: "flex",
        borderLeft: BORDER_STYLE,
        alignItems: "stretch",
        minHeight: 400,
    },
    pane: {
        overflowY: "scroll",
        flex: 1,
        minWidth: 272,
        display: "flex",
        alignItems: "stretch",
        borderTop: BORDER_STYLE,
        borderRight: BORDER_STYLE,
        borderBottom: BORDER_STYLE,
    },
    paneChildren: {
        flex: 1,
        "& .search": {
            borderWidth: 0,
        },
        "& .search + .tree": {
            borderTop: BORDER_STYLE,
        },
    },
    input: {
        padding: "6.5px 10px!important",
    },
    ghost: {
        backgroundColor: "#F3F9FC",
    },
    finder: {
        maxHeight: "70vh",
        overflow: "auto",
        "& > .search": {
            borderBottom: 0,
        },
    },
    loading: {
        opacity: 0.7,
        pointerEvents: "none",
    },
};
var useStyles = createUseStyles(styles);
export var Finder = function (_a) {
    var children = _a.children, className = _a.className, loading = _a.loading, dataId = _a.dataId, dataLabel = _a.dataLabel, dataTestId = _a.dataTestId;
    var finderRef = React.useRef(null);
    var classes = useStyles();
    var finderChildren = parseChildren(children);
    var elements = finderChildren.filterOutType(Search);
    var search = finderChildren.filterByType(Search);
    useEffect(function () {
        if (finderRef !== null && finderRef.current !== null) {
            finderRef.current.scrollTo({
                left: 200000,
                behavior: "smooth",
            });
        }
    }, [finderChildren.length]);
    return (React.createElement("div", { className: classNames(classes.finder, loading ? classes.loading : "", className || ""), "data-id": dataId, "data-label": dataLabel, "data-testid": dataTestId, ref: finderRef },
        search,
        React.createElement("div", { className: classNames(classes.panes, className ? "".concat(className, "-panes") : "") }, elements)));
};
export var FinderPane = function (_a) {
    var children = _a.children, dataId = _a.dataId, dataLabel = _a.dataLabel, dataTestId = _a.dataTestId;
    var classes = useStyles();
    return (React.createElement("div", { className: classNames(classes.pane) },
        React.createElement("div", { className: classNames(classes.paneChildren, !children ? classes.ghost : ""), "data-id": dataId, "data-label": dataLabel, "data-testid": dataTestId }, children)));
};
export var RawFinderInput = observer(function (_a) {
    var name = _a.name, onClick = _a.onClick, placeholder = _a.placeholder, label = _a.label;
    var classes = useStyles();
    placeholder = placeholder || "Please select folder";
    var values = useFormContext().values;
    return (React.createElement("span", { className: classNames(classes.input, "form-control"), role: "button", onClick: onClick, onKeyPress: onClick, tabIndex: 0, "aria-label": label }, values.get(name) || placeholder));
});
export var FinderInput = withFormWrapper({
    WrappedComponent: RawFinderInput,
    options: "omitHTMLLabel",
});
